import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { ItemImage } from '../inventory/inventoryBagGridUtils';
import WikiItemPopup from './WikiItemPopup';

const ITEM_TYPES = ['weapon', 'armor', 'helmet', 'boot', 'shield', 'earring', 'necklace', 'pot', 'other'];

const WikiItemDetail = ({ efsunProfiles, refreshKey }) => {
  const { t } = useTranslation('wiki');
  const [itemType, setItemType] = useState('weapon');
  const [items, setItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const loadItems = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const res = await axios.get('/api/wiki/items', { params: { type: itemType } });
      if (res.data?.success) {
        setItems(res.data.items || []);
      } else {
        setError(t('loadError'));
      }
    } catch {
      setError(t('loadError'));
    } finally {
      setLoading(false);
    }
  }, [itemType, t]);

  useEffect(() => {
    setSelectedItem(null);
    loadItems();
  }, [loadItems, refreshKey]);

  const handleTypeChange = (type) => {
    setSelectedItem(null);
    setItemType(type);
  };

  return (
    <div className="wiki-items-browse">
      <h4>{t('selectItemType')}</h4>
      <div className="wiki-type-tabs">
        {ITEM_TYPES.map((type) => (
          <button
            key={type}
            type="button"
            className={`wiki-type-tab ${itemType === type ? 'wiki-type-tab--active' : ''}`}
            onClick={() => handleTypeChange(type)}
          >
            {t(`itemTypes.${type}`)}
          </button>
        ))}
      </div>

      <h4>{t('selectItem')}</h4>
      {loading ? <p>{t('loading')}</p> : null}
      {error ? <p className="wiki-error">{error}</p> : null}

      {!loading && items.length === 0 ? (
        <p className="wiki-empty">{t('selectItem')}</p>
      ) : (
        <div className="wiki-item-grid">
          {items.map((item) => (
            <button
              key={item.id}
              type="button"
              className={`wiki-item-card${item.locked ? ' wiki-locked' : ''}`}
              onClick={() => !item.locked && setSelectedItem(item)}
              aria-disabled={item.locked || undefined}
            >
              {item.imageUrl ? (
                <ItemImage imageUrl={item.imageUrl} alt={item.name} className="wiki-item-card-image" />
              ) : (
                <span className="wiki-item-card-image wiki-item-thumb--placeholder">?</span>
              )}
              <span className="wiki-item-card-name">{item.name}</span>
              {!item.locked ? <span className="wiki-item-card-level">Lv.{item.level}</span> : null}
            </button>
          ))}
        </div>
      )}

      {selectedItem ? (
        <WikiItemPopup
          item={selectedItem}
          itemType={itemType}
          efsunProfiles={efsunProfiles}
          onClose={() => setSelectedItem(null)}
        />
      ) : null}
    </div>
  );
};

export default WikiItemDetail;
